import { Button, showAlert } from '@beehive/components';
import React, { useRef, useState } from 'react';
import './index.less';
import Template from '../components/Template';
import { NodeEnum, getListPathMenuKey } from 'containers/OutBidding/utils';
import { transformToBlobIds } from '../utils';
import isBlank from 'utils/object';
import _ from 'lodash';
import BiddingAgreeCheckbox from '@mpc/common/src/features/Bidding/BiddingAgreeCheckbox';
import { Modal } from '@bedrock/components';
import { useMemoizedFn } from 'ahooks';

/**
 * 待提交标书
 */
const AwaitingSubmissionBids = (props: any) => {
  const { detail = {}, editFields = [], getDetail, projectMove } = props;
  const [loading, setLoading] = useState(false);

  const { permit_actions = {} } = detail;
  const canMove = permit_actions.can_move;
  const hasSubmitted = !!canMove && !!detail?.bidding_suppliers?.[0].bidding_supplier_quotes?.[0]?.created_at
  const [agree, setAgree] = useState(false);
  const agreeCheckBoxRef = useRef<any>(null);


  const handleSubmit = async (validData: any) => {
    const params = validData();
    if (params) {
      setLoading(true);
      const { evaluationValues } = params;
      const {
        tender_plan_attach_blob_ids,
        quote_price,
        quote_currency,
        quote_price_attach_blob_ids,
      } = evaluationValues;
      const { bidding_suppliers = [] } = detail;
      const [currentSupplier] = bidding_suppliers;
      const { bidding_supplier_quotes = [] } = currentSupplier;
      const [currentQuote = {}] = bidding_supplier_quotes;
      const data = {
        bidding_supplier_id: detail.current_bidding_supplier_id,
        bidding_supplier_quote_dtos: [
          _.omitBy(
            {
              id: isBlank(currentQuote.id) ? undefined : currentQuote.id,
              tender_plan_attach_blob_ids: transformToBlobIds(
                tender_plan_attach_blob_ids
              ),
              quote_price_attach_blob_ids: transformToBlobIds(
                quote_price_attach_blob_ids
              ),
              quote_price,
              quote_currency,
            },
            _.isUndefined
          ),
        ],
      };
      try {
        await projectMove(
          {
            id: detail.id,
            pass: true,
            form: {
              ...data,
            },
            state: NodeEnum.AWAITING_SUBMISSION_BIDS,
            bidding_action: 'SUBMIT',
          },
          {
            menuKey: getListPathMenuKey(),
          }
        );
        showAlert({ type: 'success', message: '提交成功' });
        getDetail();
      } finally {
        setLoading(false);
      }
    }
  };

  const submit = useMemoizedFn(async (validData: any) => {
    const checked = await agreeCheckBoxRef.current?.getChecked()
    if (!checked) {
      return
    }
    if (hasSubmitted) {
      Modal.confirm({
        title: '您已提交过比选方案，确定再次提交吗？',
        content: '再次提交将会覆盖上次提交内容',
        onOk: () => handleSubmit(validData)
      })
      return
    }
    handleSubmit(validData)
  })
  
  return (
    <Template
      detail={detail}
      editFields={editFields}
      hasSubmitted={hasSubmitted}
      renderOpers={(validData: any) => {
        return (
          <>
            {canMove ? (
              <>
                <BiddingAgreeCheckbox
                  value={agree}
                  onChange={setAgree}
                  checkboxText='我已阅读并同意'
                  ref={agreeCheckBoxRef}
                />
                <Button
                  onClick={() => submit(validData)}
                  type="primary"
                  loading={loading}
                  disabled={loading}
                >
                  提交
                </Button>
              </>
            ) : null}
          </>
        );
      }}
    />
  );
};

export default AwaitingSubmissionBids;
